import { useMutation } from "@tanstack/react-query";
import { changeUserPassword } from "../openapi/api-client.ts";

export const useChangeUserPassword = (projectId: string) => {
  return useMutation({
    mutationFn: (params: { username: string; password: string }) => {
      return changeUserPassword(
        { password: params.password },
        {
          path: { projectId, username: params.username },
        },
      );
    },
  });
};
